import { AppState } from 'Store'

const selectData = (state: AppState) => state.referenceBooks.cities.data
const selectRequestParams = (state: AppState) => state.referenceBooks.cities.params
const selectFormState = (state: AppState) => state.referenceBooks.cities.formState
const selectTotal = (state: AppState) => state.referenceBooks.cities.data.total_entries
const selectCurrentPage = (state: AppState) => state.referenceBooks.cities.data.current_page
const selectEntries = (state: AppState) => state.referenceBooks.cities.data.entries

export const citiesSelectors = {
	selectData,
	selectRequestParams,
	selectFormState,
	selectTotal,
	selectCurrentPage,
	selectEntries,
}
